
import Vue from 'vue'
import Vuex from 'vuex'
import VuexORM from '@vuex-orm/core'
import createPersistedState from "vuex-persistedstate"

import Grid from '../models/Grid'
import { Area, Outdoor, Town, Building, Dungeon } from '../models/AreaHierarchy'
import Quest from '../models/Quest'
import Secret from '../models/Secret'
import Tome from '../models/Tome'
import Boss from '../models/Boss'
import Achievement from '../models/Achievement'
import Weapon from '../models/Weapon'


import configurations from './modules/configurations'
import grids from './modules/grids'
import areas from './modules/areas'
import quests from './modules/quests'
import bosses from './modules/bosses'
import secrets from './modules/secrets'
import tomes from './modules/tomes'
import achievements from './modules/achievements'
import weapons from './modules/weapons'


Vue.use(Vuex)

const database = new VuexORM.Database()

database.register(Grid, grids)
database.register(Area, areas)
database.register(Outdoor)
database.register(Town)
database.register(Building)
database.register(Dungeon)
database.register(Quest, quests)
database.register(Boss, bosses)
database.register(Secret, secrets)
database.register(Tome, tomes)
database.register(Achievement, achievements)
database.register(Weapon, weapons)

export default new Vuex.Store({
  modules: {
    configurations
  },
  plugins: [
    VuexORM.install(database),
    createPersistedState()
  ],
  strict: process.env.NODE_ENV !== 'production'
})